import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeWords'
})
export class CapitalizeWordsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Capitalizes the first letter of each word using regex boundaries
    return value.replace(/\b\w/g, char => char.toUpperCase());
  }
}
